import { SxProps, Theme } from '@mui/material';
import { CSSProperties } from 'react';

export const rootSx: SxProps<Theme> = {
	width: '100%',
	position: 'relative',

	'& .swiper-slide': {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: 'auto',
	},

	'& #mediaImageMainDisplay .swiper-slide': {
		width: '100%',
		aspectRatio: '1 / 1',
		height: 'auto',
	},

	'& .swiper-pagination-bullets': {
		position: 'relative',
		mt: '15px',
	},

	'& .swiper-pagination-bullet': {
		backgroundColor: 'grey.100',
		opacity: 1,
		width: '8px',
		height: '8px',
		transition: 'all 0.3s ease-in-out',
	},

	'& .swiper-pagination-bullet-active': {
		backgroundColor: 'grey.500',
		width: '35px',
		borderRadius: '4px',
		opacity: 0.8,
	},
};

export const swiperThumbsMobileOrTabletStyle: CSSProperties = {
	display: 'none',
	marginTop: '5px',
};

export const swiperThumbsDesktopStyle: CSSProperties = {
	display: 'block',
	marginTop: '5px',
};

export const thumbnailImageContainerSx: SxProps<Theme> = {
	cursor: 'pointer',
	overflow: 'hidden',
	boxSizing: 'border-box',
};

export const thumbnailImageSx: SxProps<Theme> = {
	width: '100%',
	height: 'auto',
	border: 'solid 2px',
	borderRadius: '3px',
	borderColor: 'grey.100',
	cursor: 'pointer',
	objectFit: 'contain',
};

export const thumbnailImageSelectedSx: SxProps<Theme> = {
	borderColor: 'grey.500',
};

export const thumbnailImageBottomLineSx: SxProps<Theme> = {
	display: 'block',
	backgroundColor: 'grey.500',
	width: '100%',
	height: '3px',
	borderRadius: '3px',
	mx: 'auto',
	border: 'none',
};

export const thumbnailImageBottomLinePlaceholderSx: SxProps<Theme> = {
	display: 'block',
	backgroundColor: 'transparent',
	width: '100%',
	height: '3px',
	mx: 'auto',
	border: 'none',
};

export const buttonNavigationSx: SxProps<Theme> = {
	position: 'absolute',
	top: '50%',
	transform: 'translate(0, -50%)',
	backgroundColor: 'grey.400',
	opacity: 0,
	zIndex: 1,
	borderRadius: '100%',
	transition: 'opacity 0.2s ease-in-out',
	pointerEvents: 'none',
	'&:hover': {
		backgroundColor: 'grey.500',
		border: 'none',
	},
};

export const buttonNavigationPrevSx: SxProps<Theme> = {
	...buttonNavigationSx,
	left: 0,
};

export const buttonNavigationNextSx: SxProps<Theme> = {
	...buttonNavigationSx,
	right: 0,
};

export const thumbnailNavContainerSx: SxProps<Theme> = {
	position: 'relative',
	'&:hover #mediaImageThumbnailsControlPrev, &:hover #mediaImageThumbnailsControlNext': {
		opacity: 0.8,
		pointerEvents: 'auto',
	},
};

export const portalImageSx: SxProps<Theme> = {
	position: 'absolute',
	zIndex: 500,
	right: 0,
	transform: 'translateX(100%)',
	margin: 'auto',
	'& img': {
		maxWidth: 'none',
	},
	'& div': {
		borderColor: 'grey.500',
		borderWidth: '2px',
		borderStyle: 'solid',
		borderRadius: '3px',
		backgroundColor: 'white',
	},
};

export const zoomMessageContainerSx: SxProps<Theme> = {
	zIndex: 100,
	position: 'absolute',
	backgroundColor: '#000',
	opacity: 0.3,
	bottom: '35px',
	left: '20px',
	display: 'flex',
	alignItems: 'center',
	px: '8px',
	py: '4px',
	borderRadius: '2px',
	gap: '2px',
	userSelect: 'none',
	pointerEvents: 'none',
};

export const zoomOutButtonSx: SxProps<Theme> = {
	zIndex: 100,
	position: 'absolute',
	backgroundColor: '#000',
	opacity: 0.3,
	top: '15px',
	right: '15px',
	borderRadius: '100%',
	width: '30px',
	height: '30px',
	'&:hover': {
		backgroundColor: '#000',
		border: 'none',
	},
};
